<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-23 11:04:00
 * @LastEditTime: 2019-09-06 21:49:54
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id="barrage">
    <div class="danmu1"
         :style="{top:top+'px'}"
         v-if="dataOneLine.isShow">
      <div class="danmu_shadow">
        <div class="danmu_message">{{dataOneLine.userName}} 参与了活动</div>
        <!--<div class="danmu_message">
          {{dataOneLine.userName}} 获得
          <span>{{dataOneLine.userMoney}}元</span>奖励
        </div>-->
      </div>
      <img class="danmu_icon"
           :src="dataOneLine.headImg"
           alt="">
    </div>
    <div class="danmu2"
         :style="{top:topTwo + 'px'}"
         v-if="dataTwoLine.isShow">
      <div class="danmu_shadow">
        <div class="danmu_message">{{dataTwoLine.userName}} 参与了活动</div>
        <!--<div class="danmu_message">
          {{dataTwoLine.userName}} 获得
          <span>{{dataTwoLine.userMoney}}元</span>奖励
        </div>-->
      </div>
      <img class="danmu_icon"
           :src="dataTwoLine.headImg"
           alt="">
    </div>
    <div class="danmu3"
         :style="{top:top + 'px'}"
         v-if="dataThreeLine.isShow">
      <div class="danmu_shadow">
        <div class="danmu_message">{{dataThreeLine.userName}} 参与了活动</div>
        <!--<div class="danmu_message">
          {{dataThreeLine.userName}} 获得
          <span>{{dataThreeLine.userMoney}}元</span>奖励
        </div>-->
      </div>
      <img class="danmu_icon"
           :src="dataThreeLine.headImg"
           alt="">
    </div>
    <div class="danmu4"
         :style="{top:topTwo + 'px'}"
         v-if="dataFourLine.isShow">
      <div class="danmu_shadow">
        <div class="danmu_message">{{dataFourLine.userName}} 参与了活动</div>
        <!--<div class="danmu_message">
          {{dataFourLine.userName}} 获得
          <span>{{dataFourLine.userMoney}}元</span>奖励
        </div>-->
      </div>
      <img class="danmu_icon"
           :src="dataFourLine.headImg"
           alt="">
    </div>
  </div>
</template>
<script>
let timer1 = null
let timer2 = null
let timer3 = null
let timer4 = null
export default {
  name: 'barrage',
  props: {
    data: {
      type: Array
    },
    top: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      dataOneLine: {},
      dataTwoLine: {},
      dataThreeLine: {},
      dataFourLine: {},
      barrageArr: [],
      newArr: [],
      defaultImg: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/cimen/share.png',
      topTwo: 0
    }
  },
  methods: {
    dealWithDataArray (arr) {
      let self = this
      let array = []
      arr.forEach(item => {
        let obj = {}
        obj.headImg = item.avatar && item.avatar.length > 0 ? item.avatar : self.defaultImg
        obj.userName = item.nickName ? item.nickName : '喜盈门会员'
        obj.userMoney = item.bounty
        obj.isShow = false
        array.push(obj)
      })
      return array
    },
    // 将数组随机洗牌
    getRandomArrayElements (count) {
      let arr = this.newArr
      var shuffled = arr.slice(0)
      let i = arr.length
      let min = i - count
      let temp
      let index
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random())
        temp = shuffled[index]
        shuffled[index] = shuffled[i]
        shuffled[i] = temp
      }
      return shuffled.slice(min)
    },
    /**
     * 弹幕开始滚动
     */
    startBarrageScroll () {
      var self = this
      if (timer1) clearInterval(timer1)
      if (timer2) clearInterval(timer2)
      if (timer3) clearInterval(timer3)
      if (timer4) clearInterval(timer4)
      self.dataOneScroll()
      timer1 = setInterval(() => {
        self.dataOneScroll()
      }, 4900)
      setTimeout(() => {
        self.dataTwoScroll()
        timer2 = setInterval(() => {
          self.dataTwoScroll()
        }, 4900)
      }, 1200)
      setTimeout(() => {
        self.dataThreeScroll()
        timer3 = setInterval(() => {
          self.dataThreeScroll()
        }, 4900)
      }, 2400)
      setTimeout(() => {
        self.dataFourScroll()
        timer4 = setInterval(() => {
          self.dataFourScroll()
        }, 4900)
      }, 3600)
    },
    getRealMap (arr) {
      if (arr.length !== 1) {
        return
      }
      let obj = arr[0]
      let newObj = {}
      for (let i in obj) {
        newObj[i] = obj[i]
      }
      return newObj
    },
    dataOneScroll () {
      var self = this
      let arrOne = self.getRandomArrayElements(1)
      let dataOneLine = self.getRealMap(arrOne)
      self.dataOneLine = dataOneLine
      self.dataOneLine.isShow = false
      setTimeout(() => {
        self.dataOneLine.isShow = true
      }, 100)
    },
    dataTwoScroll () {
      let self = this
      let arrTwo = self.getRandomArrayElements(1)
      let dataTwoLine = self.getRealMap(arrTwo)
      self.dataTwoLine = dataTwoLine
      self.dataTwoLine.isShow = false
      setTimeout(() => {
        self.dataTwoLine.isShow = true
      }, 100)
    },
    dataThreeScroll () {
      let self = this
      let arrTwo = self.getRandomArrayElements(1)
      let dataThreeLine = self.getRealMap(arrTwo)
      self.dataThreeLine = dataThreeLine
      self.dataThreeLine.isShow = false
      setTimeout(() => {
        self.dataThreeLine.isShow = true
      }, 100)
    },
    dataFourScroll () {
      let self = this
      let arrTwo = self.getRandomArrayElements(1)
      let dataFourLine = self.getRealMap(arrTwo)
      self.dataFourLine = dataFourLine
      self.dataFourLine.isShow = false
      setTimeout(() => {
        self.dataFourLine.isShow = true
      }, 100)
    }
  },
  mounted: function () {
    this.topTwo = parseInt(parseInt(this.top) + parseInt(25))
    this.newArr = this.dealWithDataArray(this.data)
    if (this.newArr.length > 0) { this.startBarrageScroll() }
  }
}
</script>
<style lang="less" scope>
#barrage{
  pointer-events: none;
}
.danmu1 {
  top: 0;
  z-index: 9999;
  position: fixed;
  left: 150%;
  height: 40px;
  animation: danmu 5s linear 0s 1;
  pointer-events: none;
}
.danmu2 {
  position: fixed;
  z-index: 9999;
  top: 50px;
  left: 150%;
  height: 40px;
  animation: danmu 5s linear 0s 1;
  pointer-events: none;
}
.danmu3 {
  position: fixed;
  z-index: 9999;
  left: 150%;
  height: 40px;
  animation: danmu 5s linear 0s 1;
  pointer-events: none;
}
.danmu4 {
  position: fixed;
  z-index: 9999;
  left: 150%;
  height: 40px;
  animation: danmu 5s linear 0s 1;
  pointer-events: none;
}
.danmu_icon {
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-color: #ffffff;
  border: solid 2px #eeeeee;
}
.danmu_shadow {
  position: absolute;
  left: 20px;
  top: 2px;
  background-color: #000000;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
  opacity: 0.5;
  height: 40px;
  padding-left: 32px;
}
.danmu_message {
  font-size: 24px;
  line-height: 40px;
  white-space: nowrap;
  color: #f0f0f0;
  margin-right: 16px;
  span {
    color: #ffb700;
  }
}
@keyframes danmu {
  from {
    left: 150%;
    transform: translateX(0);
  }
  to {
    left: -50%;
    transform: translateX(-200%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/barrage.vue